import { useEffect, useState } from "react";
import "../styles/incidences.scss";
import GISHeader from "../components/gis/gisheader";
import MenuTab from "../components/menu_tab";

export default function ReportIncident() {
  const [toggleMenu, setToggleMenu] = useState(false);
  const [location, setLocation] = useState(null);
  const [locationError, setLocationError] = useState("");
  const [formData, setFormData] = useState({
    incidentType: "",
    description: "",
    reportedBy: "",
    image: null, // New field
  });

  useEffect(() => {
    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by your browser.");
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      (pos) => {
        const { latitude, longitude, accuracy } = pos.coords;
        if (accuracy < 50) {
          setLocation({ latitude, longitude });
          setLocationError("");
        } else {
          setLocationError("Waiting for more accurate location...");
        }
      },
      (err) => {
        console.error(err);
        setLocationError("Location permission denied or unavailable.");
      },
      {
        enableHighAccuracy: true,
        maximumAge: 5000,
        timeout: 10000,
      }
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      setFormData((prev) => ({ ...prev, image: files[0] || null }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!location) {
      alert("Please wait for location to be acquired.");
      return;
    }

    const data = new FormData();
    data.append("incidentType", formData.incidentType);
    data.append("description", formData.description);
    data.append("reportedBy", formData.reportedBy);
    data.append("latitude", location.latitude);
    data.append("longitude", location.longitude);

    if (formData.image) {
      data.append("image", formData.image);
    }

    try {
      const response = await fetch("/api/incidences/create", {
        method: "POST",
        body: data,
      });

      if (!response.ok) {
        throw new Error(`Failed to create incident: ${response.statusText}`);
      }

      const result = await response.json();
      alert("Incident submitted successfully!");

      // Reset form
      setFormData({
        incidentType: "",
        description: "",
        reportedBy: "",
        image: null,
      });

      return result;
    } catch (error) {
      console.error("Error submitting incident:", error.message);
      alert("There was an error submitting the incident.");
    }
  };

  return (
    <div>
      <GISHeader toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      
      {toggleMenu && (
        <MenuTab toggleMenu={toggleMenu} setToggleMenu={setToggleMenu} />
      )}
      <div className="incident-form-container" style={{ padding: "20px", maxWidth: "500px", margin: "0 auto" }}>
        <h2>Report an Incident</h2>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <label>
            Incident Type:
            <select
              name="incidentType"
              value={formData.incidentType}
              onChange={handleChange}
              required
            >
              <option value="">Select type</option>
              <option value="Leak">Leak</option>
              <option value="Burst">Burst</option>
              <option value="Illegal Connection">Illegal Connection</option>
              <option value="Water Quality">Water Quality</option>
              <option value="Other">Other</option>
            </select>
          </label>
          <br /><br />

          <label>
            Description:
            <textarea
              name="description"
              value={formData.description}
              onChange={handleChange}
              required
            />
          </label>
          <br /><br />

          <label>
            Reported By:
            <input
              type="text"
              name="reportedBy"
              value={formData.reportedBy}
              onChange={handleChange}
              required
            />
          </label>
          <br /><br />

          <label>
            Capture Image:
            <input
              type="file"
              name="image"
              accept="image/*"
              capture="environment"
              onChange={handleChange}
            />
          </label>
          <br /><br />

          {location ? (
            <p style={{ color: "green" }}>
              Location acquired: ({location.latitude.toFixed(5)},{" "}
              {location.longitude.toFixed(5)})
            </p>
          ) : (
            <p style={{ color: "red" }}>{locationError || "Getting location..."}</p>
          )}

          <button type="submit" disabled={!location}>
            Submit Incident
          </button>
        </form>
      </div>
    </div>
  );
}
